import { useContext } from "react";

import AddQuoteContext, { IAddQuoteData } from "components/Quotes/AddQuote/AddQuoteContext";

export function useAddQuoteData(): IAddQuoteData {
    return useContext(AddQuoteContext);
};

export default useAddQuoteData;
